import { string, instanceOf } from 'prop-types';
import { useContext, useEffect, useState } from 'react';

export const useTNT = (props) => {
  const {
    testName,
    cookieName,
    startDate,
    endDate
  } = props;

  if (!testName) {
    throw new Error('useTNT: testName is required');
  }
  if (!cookieName) {
    throw new Error('useTNT: cookieName is required');
  }
  if (!startDate) {
    throw new Error('useTNT: startDate is required');
  }
  if (!endDate) {
    throw new Error('useTNT: endDate is required');
  }

  const now = new Date();

  const [testData, setTestData] = useState({
    enabled: false,
    loading: true,
    expired: false,
  });

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    const cookieValue = window.cookieUtils?.readBrowserCookie(cookieName);
    if (now > startDate && now < endDate && cookieValue) {
      const re = new RegExp(testName);
      if (re.test(cookieValue)) {
        setTestData({
          enabled: true,
          loading: false,
          expired: false,
        });
      } else {
        setTestData({
          enabled: false,
          loading: false,
          expired: false,
        });
      }
    } else if (now > endDate) {
      setTestData({
        enabled: false,
        loading: false,
        expired: true,
      });
    } else {
      setTestData({
        enabled: false,
        loading: false,
        expired: false,
      });
    }
  }, []);

  useEffect(() => {
    if (testData.enabled) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('tnt.enabled', props);
    }
  }, [testData.enabled]);

  useEffect(() => {
    if (testData.expired) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('tnt.expired', props);
    }
  }, [testData.expired]);

  return {
    ...testData
  };
};

useTNT.propTypes = {
  testName: string.isRequired,
  cookieName: string.isRequired,
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
};
